import React from 'react';
import PropTypes from 'prop-types';
export default class Counter extends React.Component {
    render() {
        let classname = 'counter';
        if (this.props.top) {
            classname = 'counter-top';
        }
        return React.createElement("div", { className: classname }, this.props.count);
    }
}
Counter.propTypes = {
    count: PropTypes.number.isRequired,
    top: PropTypes.bool,
};
